module.exports = __webpack_public_path__ + "img/icon-ai-change-line@2x.724d7883.png";